module.exports = __webpack_public_path__ + "img/img_06_brand_retail@3x.702bd97e.png";